import { useEffect } from "react";
import { Back, gsap } from "gsap";

import { color } from "../designTokens";

const Navigation = () => {
  useEffect(() => {
    gsap.to(".navigation", {
      scrollTrigger: {
        trigger: ".nav",
        start: "center top",
        scrub: 1.5,
      },
      backgroundColor: color.primary,
      color: color.secondary,
      borderRadius: "5rem",
      padding: "2rem",
      ease: Back.easeOut.config(2),
    });

    gsap.to(".navigation path", {
      scrollTrigger: {
        trigger: ".nav",
        start: "center top",
        scrub: 1.5,
      },
      fill: color.secondary,
    });
  }, []);

  return (
    <div className="navigation inverseNav">
      <div className="text-M-large">work</div>
      <svg
        width="26"
        height="26"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32ZM18 10C18 9.46957 17.7893 8.96086 17.4142 8.58579C17.0391 8.21071 16.5304 8 16 8C15.4696 8 14.9609 8.21071 14.5858 8.58579C14.2107 8.96086 14 9.46957 14 10V17.172L11.414 14.586C11.0368 14.2217 10.5316 14.0201 10.0072 14.0247C9.4828 14.0292 8.98118 14.2395 8.61036 14.6104C8.23955 14.9812 8.02921 15.4828 8.02465 16.0072C8.02009 16.5316 8.22168 17.0368 8.586 17.414L14.586 23.414C14.9611 23.7889 15.4697 23.9996 16 23.9996C16.5303 23.9996 17.0389 23.7889 17.414 23.414L23.414 17.414C23.7783 17.0368 23.9799 16.5316 23.9753 16.0072C23.9708 15.4828 23.7605 14.9812 23.3896 14.6104C23.0188 14.2395 22.5172 14.0292 21.9928 14.0247C21.4684 14.0201 20.9632 14.2217 20.586 14.586L18 17.172L18 10Z"
          fill="#B7AB98"
        />
      </svg>
    </div>
  );
};

export default Navigation;
